import React, { useEffect } from "react";
import {
  OWNERSHIP_TRANSFER_NOTE,
  ownershipSeatSentence,
  ownershipTransferSentence,
} from "../../lib/memberManagement";

/**
 * Прехвърляне на собствеността — the one high-impact Owner action.
 *
 * It states the FULL consequence before anything happens: who becomes
 * Собственик, that the acting Owner becomes Търговец, that offers and customers
 * stay exactly where they are, and what happens to the licensed seats. One
 * explicit confirmation click is required and nothing is pre-selected, which is
 * the same weight OfferTrace gives every other destructive confirmation - there
 * is no typed-name pattern anywhere in the product, so none is invented here.
 *
 * A transfer the database says is impossible right now is shown with its reason
 * in Bulgarian and the confirmation stays disabled; the database refuses it again
 * regardless of what this screen believes.
 */
export const MemberOwnershipDialog = ({
  open,
  member,
  impact,
  loading,
  error,
  submitting,
  onCancel,
  onSubmit,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !submitting) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, submitting, onCancel]);

  if (!open || !member) return null;

  const name =
    [member.first_name, member.last_name].filter(Boolean).join(" ") ||
    member.full_name ||
    member.email;
  const blocker = impact?.blocking_message || "";
  const seatLine = ownershipSeatSentence(impact?.seat_effect, impact?.target?.role);
  const ready = !loading && impact?.allowed === true;

  return (
    <div className="qw-modal-backdrop">
      <div
        className="qw-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="member-ownership-title"
        data-testid="member-ownership-dialog"
      >
        <div className="h" id="member-ownership-title">
          Прехвърляне на собствеността
        </div>
        <div className="body">
          <p style={{ margin: 0, fontSize: 13, color: "#475569" }}>
            {member.email}
            {member.role_label ? ` — ${member.role_label}` : ""}
          </p>

          {loading && (
            <p className="qw-help" data-testid="member-ownership-loading">
              Проверка на условията…
            </p>
          )}

          {!loading && (
            <>
              <p
                style={{ marginTop: 12, fontSize: 13, color: "#0f172a" }}
                data-testid="member-ownership-sentence"
              >
                {ownershipTransferSentence(name)}
              </p>
              <div className="qw-help" data-testid="member-ownership-note">
                {OWNERSHIP_TRANSFER_NOTE}
              </div>
              {seatLine && (
                <div className="qw-help" data-testid="member-ownership-seat-line">
                  {seatLine}
                </div>
              )}
              {blocker && (
                <div className="qw-error" data-testid="member-ownership-blocked">
                  {blocker}
                </div>
              )}
            </>
          )}

          {error && (
            <div
              className="qw-error"
              role="alert"
              style={{ marginTop: 10 }}
              data-testid="member-ownership-error"
            >
              {error}
            </div>
          )}
        </div>
        <div className="footer">
          <button
            type="button"
            className="qw-btn ghost"
            onClick={onCancel}
            disabled={submitting}
            data-testid="member-ownership-cancel"
          >
            Отказ
          </button>
          <button
            type="button"
            className="qw-btn danger"
            onClick={onSubmit}
            disabled={submitting || !ready}
            data-testid="member-ownership-confirm"
          >
            {submitting ? "Прехвърляне…" : "Прехвърли собствеността"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MemberOwnershipDialog;
